export default "__VITE_ASSET__BHCQKM7U__"